import api from "../../utils/api";
import { setAlert } from './alert';
import {
  LOADING,
  APPROVED_BOOKING,
  DECLINED_BOOKING,
  DELETE_BOOKING_DATA,
  GET_BOOKING_DATA,
  GET_BOOKING_DETAIL_DATA,
  GET_EMAIL_NOTIFICATION,
  GET_PERK_DATA,
} from "../types";

// create booking
export const createBooking = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/booking`, data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getBookingData = () => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.get('/booking');
    dispatch({
      type: GET_BOOKING_DATA,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getBookingDetail = (bookingId) => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.get(`/booking/detail/${bookingId}`);
    dispatch({
      type: GET_BOOKING_DETAIL_DATA,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const approveBooking = (bookingId) => async (dispatch) => {
  try {
    const res = await api.put(`/booking/detail/${bookingId}`, { status: 2 });
    dispatch({
      type: APPROVED_BOOKING,
      payload: 2
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const declineBooking = (bookingId) => async (dispatch) => {
  try {
    const res = await api.patch(`/booking/detail/${bookingId}`, { status: 1 });
    dispatch({
      type: DECLINED_BOOKING,
      payload: 1
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const deleteBookings = (data) => async (dispatch) => {

  try {
    const res = await api.post('/booking/delete', data);
    dispatch({
      type: DELETE_BOOKING_DATA,
      payload: data.bookingIds
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getBookingFormData = (bookFormId) => async (dispatch) => {
  try {
    const res = await api.get(`/booking/get-form/${bookFormId}`);
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data
    })
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getBookingFormDataByUsername = (username) => async (dispatch) => {
  try {
    const res = await api.get(`/booking/get-form-by-username/${username}`);
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const customBookingForm = (data) => async (dispatch) => {
  try {
    const res = await api.post('/booking/custom-booking', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const customEmailNotification = (data) => async (dispatch) => {
  try {
    const res = await api.post('/booking/custom-email-notification', data);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const searchBooking = (data) => async (dispatch) => {
  try {
    const res = await api.post('/booking/search-booking', data);
    dispatch({
      type: GET_BOOKING_DATA,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const customizeOnboardForm = (data) => async (dispatch) => {
  try {
    const res = await api.post('/booking/customize-onboard-form', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const sendWelcomePackMail = (data) => async (dispatch) => {
  try {
    const { isTest = false } = data;
    dispatch({ type: LOADING });
    const res = await api.post('/booking/onboard', data);
    if (!isTest) {
      dispatch({
        type: GET_BOOKING_DATA,
        payload: res.data
      });
    }
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const increaseBookingFormVisitCount = (username) => async (dispatch) => {
  try {
    const res = await api.get(`/booking/increase-book-form-visit-count/${username}`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getDashboardInfo = () => async (dispatch) => {
  try {
    const res = await api.get(`/booking/dashboard-info`);
    dispatch({
      type: GET_PERK_DATA,
      payload: res.data.perkData
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const updateBookFormSettings = (data) => async (dispatch) => {
  try {
    const res = await api.post('/booking/update-bookform-settings', data);
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data
    })
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

// create ticket
export const createTicket = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/booking/create-ticket`, data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}
